export default [
  {
    path: 'registro',
    name: 'registro',
    component: () => import('./views/CertificationView.vue'),
    meta: { 
      requiresAuth: true,
      title: 'Registro de Inspección',
      menuResource: 'REGISTRO_INSPECCION',
      fullScreen: true   // ← solo esto
    },
  },
]